///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.workflows = abcsetup.workflows || {};
abcsetup.workflows.show = abcsetup.workflows.show || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.workflows.show = {
    init: function() {
        abcsetup.setTitle('Workflows');

        // Adjust the history table height
        this.resize();
        $(window).on('resize', () => this.resize());

        abcsetup.workflows.chart.init($('#canDrag').val() == '1');

        // Init history datatable
        abcsetup.datatables.client_side.init($('#history_table'), {
            'dom': 'x',
            'iDisplayLength': -1,
            'order': [[1, 'asc']],
            'responsive': false,
        });
    },

    /**
     * Adjust the history table height
     */
    resize: function() {
        $('#nav-history .scroll').slimScroll({
            height: $(window).height() - 410,
            position: 'right',
            railVisible: true,
            alwaysVisible: true,
        });
    },
}
